var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEntrega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#21C5E5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.732 7.47H1.407v.703h3.325v4.884h1.21a2.122 2.122 0 0 0 2.09 1.778 2.122 2.122 0 0 0 2.09-1.778h6.83a2.122 2.122 0 0 0 2.09 1.778 2.123 2.123 0 0 0 2.091-1.778h1.21V6.662l-3.352-3.351H15.58V.165H4.732v2.806H2.407v.702h2.325v1.548H.157v.702h4.575v1.548zm3.3 6.663a1.42 1.42 0 0 1-1.418-1.419 1.42 1.42 0 0 1 1.418-1.418 1.42 1.42 0 0 1 1.419 1.418 1.42 1.42 0 0 1-1.419 1.419zm11.01 0a1.42 1.42 0 0 1-1.418-1.419 1.42 1.42 0 0 1 1.419-1.418 1.42 1.42 0 0 1 1.418 1.418 1.42 1.42 0 0 1-1.418 1.419zM15.58 4.013h3.122l2.94 2.94v5.402h-.51a2.123 2.123 0 0 0-2.088-1.761 2.122 2.122 0 0 0-2.088 1.761H10.12a2.122 2.122 0 0 0-2.088-1.761 2.122 2.122 0 0 0-2.088 1.761h-.51v-2.05H15.58V4.013zM5.434 5.221V3.673h2.223v-.702H5.434V.867h9.443v8.735H5.434V8.173h2.723v-.702H5.434V5.923h1.223v-.702H5.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.543 7.423L18.23 5.111H16.69v3.854h3.854V7.423zm-.703.84h-2.449v-2.45h.549l1.9 1.901v.549z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEntrega);
export default __webpack_public_path__ + "static/media/icon-entrega.e1c7e03d109f376ce15066d1ed4e9cd0.svg";
export { ForwardRef as ReactComponent };